(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const updateHeaderCartCount = (itemCount) => {
      const cartLink = document.querySelector('.site-header__icon-action.site-header__cart');
      const count = cartLink?.querySelector('.site-header__cart-count');

      if (count) {
        if (itemCount > 0) {
          count.textContent = String(itemCount);
        } else {
          count.remove();
        }
      }

      const currentLabel = cartLink?.getAttribute('aria-label');
      if (currentLabel && /\d+/.test(currentLabel)) {
        cartLink.setAttribute('aria-label', currentLabel.replace(/\d+/, String(itemCount)));
      }
    };

    const renderUpdatedCart = (root, cart, sectionId, line, focusTarget) => {
      const sectionHtml = cart.sections?.[sectionId];
      if (!sectionHtml) throw new Error('Cart section HTML was not returned.');

      const parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const updatedRoot = parsedDocument.querySelector('[data-cart-page]');
      if (!updatedRoot) throw new Error('Updated cart markup was not found.');

      root.replaceWith(updatedRoot);
      updateHeaderCartCount(cart.item_count);
      initCart(updatedRoot);

      const status = updatedRoot.querySelector('[data-cart-status]');
      if (status) status.textContent = updatedRoot.dataset.updatedMessage;

      const updatedControl = updatedRoot.querySelector(`[data-cart-line="${line}"]`);
      const focusSelectors = {
        decrease: '[data-cart-quantity-decrease]',
        increase: '[data-cart-quantity-increase]',
        input: '[data-cart-quantity-input]',
      };
      const elementToFocus = updatedControl?.querySelector(focusSelectors[focusTarget]);
      if (elementToFocus) requestAnimationFrame(() => elementToFocus.focus());

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    const initCart = (root) => {
      if (root.dataset.cartInitialized === 'true') return;
      root.dataset.cartInitialized = 'true';

      root.querySelectorAll('[data-cart-quantity]').forEach((control) => {
        const input = control.querySelector('[data-cart-quantity-input]');
        const decreaseButton = control.querySelector('[data-cart-quantity-decrease]');
        const increaseButton = control.querySelector('[data-cart-quantity-increase]');
        const line = Number(control.dataset.cartLine);
        const minimum = Number(control.dataset.minimum || 1);
        const increment = Number(control.dataset.increment || 1);
        const maximum = control.dataset.maximum ? Number(control.dataset.maximum) : Number.POSITIVE_INFINITY;

        const normalizeQuantity = (requestedValue) => {
          const safeValue = Number.isFinite(requestedValue) ? requestedValue : minimum;
          const steppedValue = minimum + Math.round((safeValue - minimum) / increment) * increment;
          return Math.min(maximum, Math.max(minimum, steppedValue));
        };

        const updateQuantity = (requestedValue) => {
          const quantity = normalizeQuantity(requestedValue);
          input.value = String(quantity);
          decreaseButton.disabled = quantity <= minimum;
          increaseButton.disabled = quantity >= maximum;
        };

        const changeQuantity = async (requestedValue, focusTarget) => {
          const previousQuantity = Number(control.dataset.currentQuantity);
          const quantity = normalizeQuantity(requestedValue);

          updateQuantity(quantity);
          if (quantity === previousQuantity) return;

          root.setAttribute('aria-busy', 'true');
          decreaseButton.disabled = true;
          increaseButton.disabled = true;
          input.disabled = true;

          const status = root.querySelector('[data-cart-status]');
          if (status) status.textContent = root.dataset.updatingMessage;

          try {
            const sectionId = root.dataset.sectionId;
            const routeRoot = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${routeRoot}cart/change.js`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                line,
                quantity,
                sections: [sectionId],
                sections_url: window.location.pathname,
              }),
            });
            const cart = await response.json();

            if (!response.ok) {
              throw new Error(cart.description || root.dataset.updateErrorMessage);
            }

            renderUpdatedCart(root, cart, sectionId, line, focusTarget);
          } catch (error) {
            updateQuantity(previousQuantity);
            control.dataset.currentQuantity = String(previousQuantity);
            input.disabled = false;
            root.removeAttribute('aria-busy');
            if (status) status.textContent = root.dataset.updateErrorMessage;
            console.error(error);
          }
        };

        decreaseButton.addEventListener('click', () => {
          changeQuantity(Number(input.value) - increment, 'decrease');
        });

        increaseButton.addEventListener('click', () => {
          changeQuantity(Number(input.value) + increment, 'increase');
        });

        input.addEventListener('change', () => changeQuantity(Number(input.value), 'input'));
        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          input.blur();
        });
      });
    };

    const initAllCarts = (scope = document) => {
      scope.querySelectorAll('[data-cart-page]').forEach(initCart);
    };

    initAllCarts();
    document.addEventListener('shopify:section:load', (event) => initAllCarts(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const closeMobileNavigation = (mobileMenu, restoreFocus = false) => {
    if (!(mobileMenu instanceof HTMLDetailsElement)) return

    mobileMenu.open = false

    if (restoreFocus) {
      mobileMenu.querySelector('summary')?.focus()
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return

    const navigationLink = event.target.closest(
      '[data-header-mobile-navigation] a'
    )

    if (!navigationLink) return

    const mobileMenu = navigationLink.closest('[data-header-mobile-menu]')
    closeMobileNavigation(mobileMenu)
  })

  document
    .querySelectorAll('[data-header-mobile-account]')
    .forEach((account) => {
      const mobileMenu = account.closest('[data-header-mobile-menu]')

      account.addEventListener('open', () => {
        mobileMenu?.setAttribute('data-account-sheet-open', '')
      })

      account.addEventListener('close', () => {
        mobileMenu?.removeAttribute('data-account-sheet-open')
        closeMobileNavigation(mobileMenu, true)
      })
    })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return

    document
      .querySelectorAll(
        '[data-header-mobile-menu][open]:not([data-account-sheet-open])'
      )
      .forEach((mobileMenu) => closeMobileNavigation(mobileMenu, true))
  })

  const desktopHeaderMediaQuery = window.matchMedia('(min-width: 900px)')

  desktopHeaderMediaQuery.addEventListener('change', (event) => {
    if (!event.matches) return

    document
      .querySelectorAll('[data-header-mobile-menu][open]')
      .forEach((mobileMenu) => closeMobileNavigation(mobileMenu))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"]) return;
  try {
    
  (() => {
    function initializeHomeHero(hero) {
      if (hero.dataset.initialized === 'true') {
        return;
      }

      hero.dataset.initialized = 'true';

      const video = hero.querySelector('[data-home-hero-video]');
      const poster = hero.querySelector('.home-hero__poster');
      const motionToggle = hero.querySelector('[data-home-hero-toggle]');
      const reducedMotionQuery = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );
      const mobileMediaQuery = window.matchMedia('(max-width: 559px)');

      if (!video?.querySelector('source[src]') || !motionToggle) {
        if (motionToggle) {
          motionToggle.hidden = true;
        }

        return;
      }

      let isPaused = true;

      function updateMotionToggle() {
        const label = isPaused
          ? hero.dataset.playLabel
          : hero.dataset.pauseLabel;

        motionToggle.dataset.motionState = isPaused ? 'paused' : 'playing';
        motionToggle.setAttribute('aria-label', label);
      }

      async function playVideo() {
        try {
          await video.play();
        } catch {
          isPaused = true;
          updateMotionToggle();
          return;
        }

        isPaused = false;
        updateMotionToggle();
      }

      video.addEventListener('playing', () => {
        if (poster && !poster.classList.contains('is-hidden')) {
          video.addEventListener(
            'transitionend',
            (event) => {
              if (event.propertyName === 'opacity') {
                poster.classList.add('is-hidden');
              }
            },
            { once: true }
          );
        }

        video.classList.add('is-active');
      });

      motionToggle.addEventListener('click', () => {
        if (isPaused) {
          void playVideo();
          return;
        }

        video.pause();
        isPaused = true;
        updateMotionToggle();
      });

      mobileMediaQuery.addEventListener('change', () => {
        const shouldResume = !isPaused && !reducedMotionQuery.matches;

        video.pause();
        video.classList.remove('is-active');
        poster?.classList.remove('is-hidden');
        video.load();

        if (shouldResume) {
          void playVideo();
        }
      });

      if (reducedMotionQuery.matches) {
        video.pause();
        isPaused = true;
        motionToggle.hidden = false;
        updateMotionToggle();
        return;
      }

      let hasStartedInitialPlayback = false;

      function startInitialPlayback() {
        if (hasStartedInitialPlayback) {
          return;
        }

        hasStartedInitialPlayback = true;
        motionToggle.hidden = false;
        void playVideo();
      }

      if (
        document.documentElement.classList.contains('home-intro-pending') ||
        document.documentElement.classList.contains('home-intro-active')
      ) {
        document.addEventListener(
          'blissmile:home-intro-complete',
          startInitialPlayback,
          { once: true }
        );
        return;
      }

      startInitialPlayback();
    }

    function initializeHomeHeroes(root) {
      const heroes = root.matches?.('[data-home-hero]')
        ? [root]
        : root.querySelectorAll('[data-home-hero]');

      heroes.forEach(initializeHomeHero);
    }

    initializeHomeHeroes(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHomeHeroes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-intro"]) return;
  try {
    
  (() => {
    const completionEventName = 'blissmile:home-intro-complete';
    const fadeDuration = 1400;

    function initializeHomeIntro(intro) {
      if (
        intro.dataset.initialized === 'true' ||
        !document.documentElement.classList.contains('home-intro-pending')
      ) {
        return;
      }

      intro.dataset.initialized = 'true';

      const mediaContainer = intro.querySelector('[data-home-intro-media]');
      const mediaTemplate = intro.querySelector('[data-home-intro-media-template]');
      const initialFocus = intro.querySelector('[data-home-intro-initial-focus]');
      const skipButton = intro.querySelector('[data-home-intro-skip]');

      function signalCompletion() {
        document.dispatchEvent(new CustomEvent(completionEventName));
      }

      function clearPageState() {
        document.documentElement.classList.remove(
          'home-intro-pending',
          'home-intro-active'
        );
      }

      if (!mediaContainer || !mediaTemplate || !initialFocus || !skipButton) {
        clearPageState();
        signalCompletion();
        intro.remove();
        return;
      }

      mediaContainer.append(mediaTemplate.content.cloneNode(true));

      const video = intro.querySelector('[data-home-intro-video]');
      const poster = intro.querySelector('[data-home-intro-poster]');

      if (!video || !video.querySelector('source[src]')) {
        clearPageState();
        signalCompletion();
        intro.remove();
        return;
      }

      let isFinishing = false;
      let completionSignaled = false;
      let closeTimer;
      let safetyTimer;
      let startupTimer;

      const reducedMotionQuery = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      function markIntroSeen() {
        try {
          window.sessionStorage.setItem(intro.dataset.storageKey, '1');
        } catch (_error) {
          // The intro still works when session storage is unavailable.
        }
      }

      function signalCompletionOnce() {
        if (completionSignaled) {
          return;
        }

        completionSignaled = true;
        signalCompletion();
      }

      function removeReducedMotionListener() {
        if (typeof reducedMotionQuery.removeEventListener === 'function') {
          reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);
        } else {
          reducedMotionQuery.removeListener(handleReducedMotionChange);
        }
      }

      function finalizeIntro() {
        window.clearTimeout(closeTimer);
        window.clearTimeout(safetyTimer);
        window.clearTimeout(startupTimer);
        window.removeEventListener('pageshow', handlePageShow);
        removeReducedMotionListener();

        video.pause();
        video.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('src');
        });
        video.load();

        if (intro.open) {
          intro.close();
        }

        clearPageState();
        intro.remove();
      }

      function finishIntro(immediate = false) {
        if (isFinishing) {
          return;
        }

        isFinishing = true;
        markIntroSeen();
        window.clearTimeout(safetyTimer);
        window.clearTimeout(startupTimer);
        video.pause();
        signalCompletionOnce();

        if (immediate || reducedMotionQuery.matches) {
          finalizeIntro();
          return;
        }

        intro.classList.add('is-fading');
        closeTimer = window.setTimeout(finalizeIntro, fadeDuration);
      }

      function handlePageShow(event) {
        if (event.persisted) {
          finishIntro(true);
        }
      }

      function handleReducedMotionChange(event) {
        if (event.matches) {
          finishIntro(true);
        }
      }

      function revealFirstFrame() {
        video.classList.add('is-ready');
        poster?.classList.add('is-hidden');
      }

      video.addEventListener('ended', () => finishIntro());
      video.addEventListener('error', () => finishIntro(true));
      skipButton.addEventListener('click', () => finishIntro());
      intro.addEventListener('cancel', (event) => {
        event.preventDefault();
        finishIntro();
      });
      window.addEventListener('pageshow', handlePageShow);

      if (typeof reducedMotionQuery.addEventListener === 'function') {
        reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
      } else {
        reducedMotionQuery.addListener(handleReducedMotionChange);
      }

      const canUseVideoFrameCallback =
        typeof video.requestVideoFrameCallback === 'function';

      if (!canUseVideoFrameCallback) {
        video.addEventListener('loadeddata', revealFirstFrame, { once: true });
      }

      try {
        intro.showModal();
      } catch (_error) {
        finishIntro(true);
        return;
      }

      document.documentElement.classList.remove('home-intro-pending');
      document.documentElement.classList.add('home-intro-active');
      markIntroSeen();
      initialFocus.focus({ preventScroll: true });

      const maxWait = Math.max(10000, Number(intro.dataset.maxWait) || 0);

      video.addEventListener(
        'playing',
        () => {
          window.clearTimeout(startupTimer);
          safetyTimer = window.setTimeout(() => finishIntro(), maxWait);
        },
        { once: true }
      );

      video.muted = true;
      video.load();

      if (canUseVideoFrameCallback) {
        video.requestVideoFrameCallback(revealFirstFrame);
      }

      startupTimer = window.setTimeout(() => finishIntro(true), 5000);

      const playback = video.play();

      if (playback) {
        playback.catch(() => finishIntro(true));
      }
    }

    function initializeHomeIntros(root) {
      const intros = root.matches?.('[data-home-intro]')
        ? [root]
        : root.querySelectorAll('[data-home-intro]');

      intros.forEach(initializeHomeIntro);
    }

    initializeHomeIntros(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHomeIntros(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonial"]) return;
  try {
    
  (() => {
    const initializeTestimonialCarousels = (scope = document) => {
      scope.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
        if (carousel.dataset.testimonialCarouselInitialized === 'true') return;
        carousel.dataset.testimonialCarouselInitialized = 'true';

        const slides = Array.from(carousel.querySelectorAll('[data-testimonial-slide]'));
        const viewport = carousel.querySelector('.home-testimonial__viewport');
        const previousButton = carousel.querySelector('[data-testimonial-previous]');
        const nextButton = carousel.querySelector('[data-testimonial-next]');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoplayDelay = 4000;
        const transitionDuration = 700;
        const dragSettleDuration = 350;
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let autoplayTimer = null;
        let transitionTimer = null;
        let pointerStart = null;
        let wheelAccumulator = 0;
        let wheelGestureLocked = false;
        let wheelResetTimer = null;
        const swipeThreshold = 48;
        const wheelThreshold = 36;

        const setActiveSlide = (index) => {
          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === index;
            slide.className = slide.className
              .replace(/\s+is-(?:active|positioning|entering-next|entering-previous|exiting-next|exiting-previous|dragging-slide|drag-companion|drag-settling)/g, '')
              .concat(isActive ? ' is-active' : '');
            slide.style.removeProperty('transform');
            slide.setAttribute('aria-hidden', String(!isActive));
          });
          activeIndex = index;
        };

        const showSlide = (index, direction = 1) => {
          if (index === activeIndex || transitionTimer) return;

          if (prefersReducedMotion.matches) {
            setActiveSlide(index);
            return;
          }

          const currentSlide = slides[activeIndex];
          const nextSlide = slides[index];
          const enteringClass = direction > 0 ? 'is-entering-next' : 'is-entering-previous';
          const exitingClass = direction > 0 ? 'is-exiting-next' : 'is-exiting-previous';

          currentSlide.classList.remove('is-active');
          currentSlide.classList.add(exitingClass);
          currentSlide.setAttribute('aria-hidden', 'true');
          nextSlide.classList.add('is-positioning', enteringClass);
          nextSlide.setAttribute('aria-hidden', 'false');
          void nextSlide.offsetWidth;
          nextSlide.classList.remove('is-positioning', enteringClass);
          nextSlide.classList.add('is-active');
          activeIndex = index;

          transitionTimer = window.setTimeout(() => {
            currentSlide.classList.remove(exitingClass);
            transitionTimer = null;
          }, transitionDuration);
        };

        const stopAutoplay = () => {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (prefersReducedMotion.matches || slides.length < 2) return;

          autoplayTimer = window.setInterval(() => {
            showSlide((activeIndex + 1) % slides.length);
          }, autoplayDelay);
        };

        const showPreviousSlide = () => {
          showSlide((activeIndex - 1 + slides.length) % slides.length, -1);
        };

        const showNextSlide = () => {
          showSlide((activeIndex + 1) % slides.length, 1);
        };

        previousButton?.addEventListener('click', () => {
          showPreviousSlide();
        });

        nextButton?.addEventListener('click', () => {
          showNextSlide();
        });

        viewport?.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (transitionTimer || slides.length < 2) return;

          pointerStart = {
            x: event.clientX,
            y: event.clientY,
            deltaX: 0,
            direction: 0,
            companionIndex: null,
            pointerType: event.pointerType,
          };
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture?.(event.pointerId);
          stopAutoplay();
        });

        viewport?.addEventListener('pointermove', (event) => {
          if (!pointerStart) return;

          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
          if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

          event.preventDefault();
          const direction = deltaX < 0 ? 1 : -1;
          const companionIndex = (activeIndex + direction + slides.length) % slides.length;
          const currentSlide = slides[activeIndex];

          if (pointerStart.companionIndex !== companionIndex) {
            if (pointerStart.companionIndex !== null) {
              const previousCompanion = slides[pointerStart.companionIndex];
              previousCompanion.classList.remove('is-drag-companion');
              previousCompanion.style.removeProperty('transform');
            }

            slides[companionIndex].classList.add('is-drag-companion');
            pointerStart.companionIndex = companionIndex;
          }

          const slideWidth = viewport.clientWidth + 1;
          const companionSlide = slides[companionIndex];
          currentSlide.classList.add('is-dragging-slide');
          currentSlide.style.transform = `translate3d(${deltaX}px, 0, 0)`;
          companionSlide.style.transform = `translate3d(${direction * slideWidth + deltaX}px, 0, 0)`;
          pointerStart.deltaX = deltaX;
          pointerStart.direction = direction;
        });

        const finishPointerGesture = (shouldCommit) => {
          if (!pointerStart) return;

          const gesture = pointerStart;
          const wasTouchGesture = gesture.pointerType !== 'mouse';
          const currentSlide = slides[activeIndex];
          const companionSlide = gesture.companionIndex === null ? null : slides[gesture.companionIndex];
          pointerStart = null;
          viewport.classList.remove('is-dragging');

          if (!companionSlide) {
            currentSlide.classList.remove('is-dragging-slide');
            currentSlide.style.removeProperty('transform');
            if (wasTouchGesture) startAutoplay();
            return;
          }

          const slideWidth = viewport.clientWidth + 1;
          currentSlide.classList.remove('is-dragging-slide');
          companionSlide.classList.remove('is-drag-companion');
          currentSlide.classList.add('is-drag-settling');
          companionSlide.classList.add('is-drag-settling');
          void viewport.offsetWidth;

          if (shouldCommit) {
            currentSlide.style.transform = `translate3d(${-gesture.direction * slideWidth}px, 0, 0)`;
            companionSlide.style.transform = 'translate3d(0, 0, 0)';
          } else {
            currentSlide.style.transform = 'translate3d(0, 0, 0)';
            companionSlide.style.transform = `translate3d(${gesture.direction * slideWidth}px, 0, 0)`;
          }

          transitionTimer = window.setTimeout(() => {
            currentSlide.classList.remove('is-drag-settling');
            currentSlide.style.removeProperty('transform');
            companionSlide.classList.remove('is-drag-settling');
            companionSlide.style.removeProperty('transform');

            if (shouldCommit) {
              currentSlide.classList.remove('is-active');
              currentSlide.setAttribute('aria-hidden', 'true');
              companionSlide.classList.add('is-active');
              companionSlide.setAttribute('aria-hidden', 'false');
              activeIndex = gesture.companionIndex;
            }

            transitionTimer = null;
          }, dragSettleDuration);

          if (wasTouchGesture) startAutoplay();
        };

        viewport?.addEventListener('pointerup', () => {
          if (!pointerStart) return;

          finishPointerGesture(Math.abs(pointerStart.deltaX) >= swipeThreshold);
        });

        viewport?.addEventListener('pointercancel', () => {
          finishPointerGesture(false);
        });

        viewport?.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 1) return;
          const horizontalDelta = event.deltaMode === 1 ? event.deltaX * 16 : event.deltaX;

          event.preventDefault();
          stopAutoplay();
          window.clearTimeout(wheelResetTimer);
          wheelResetTimer = window.setTimeout(() => {
            wheelAccumulator = 0;
            wheelGestureLocked = false;
          }, 220);

          if (wheelGestureLocked || transitionTimer || pointerStart) return;

          wheelAccumulator += horizontalDelta;
          if (Math.abs(wheelAccumulator) < wheelThreshold) return;

          wheelGestureLocked = true;
          if (wheelAccumulator > 0) {
            showNextSlide();
          } else {
            showPreviousSlide();
          }
        }, { passive: false });

        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', (event) => {
          if (!carousel.contains(event.relatedTarget)) startAutoplay();
        });

        startAutoplay();
      });
    };

    initializeTestimonialCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeTestimonialCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"]) return;
  try {
    
  (() => {
    const initFeatures = (root) => {
      if (root.dataset.featuresInitialized === 'true') return;
      root.dataset.featuresInitialized = 'true';

      const triggers = Array.from(root.querySelectorAll('[data-feature-trigger]'));
      const panels = Array.from(root.querySelectorAll('[data-feature-panel]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let timer = null;
      let isNearViewport = false;

      const render = (index) => {
        triggers.forEach((trigger, triggerIndex) => {
          const isActive = triggerIndex === index;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-pressed', String(isActive));
        });

        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
          panel.classList.toggle('is-active', panelIndex === index);
        });
      };

      const stopTimer = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
      };

      const startTimer = () => {
        stopTimer();
        if (!isNearViewport || reduceMotion || triggers.length < 2) return;
        timer = window.setTimeout(() => {
          activeIndex = (activeIndex + 1) % triggers.length;
          render(activeIndex);
          startTimer();
        }, 4200);
      };

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          activeIndex = index;
          render(activeIndex);
          startTimer();
        });
        trigger.addEventListener('mouseenter', () => {
          stopTimer();
          render(index);
        });
        trigger.addEventListener('mouseleave', () => {
          render(activeIndex);
          startTimer();
        });
        trigger.addEventListener('focus', () => {
          stopTimer();
          render(index);
        });
        trigger.addEventListener('blur', () => {
          render(activeIndex);
          startTimer();
        });
      });

      render(activeIndex);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            isNearViewport = entries.some((entry) => entry.isIntersecting);
            if (isNearViewport) startTimer();
            else stopTimer();
          },
          { rootMargin: '240px 0px' }
        );
        observer.observe(root);
      } else {
        isNearViewport = true;
        startTimer();
      }
    };

    const initAllFeatures = (scope = document) => {
      scope.querySelectorAll('[data-product-features]').forEach(initFeatures);
    };

    initAllFeatures();
    document.addEventListener('shopify:section:load', (event) => initAllFeatures(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const selector = '[data-product-root]';

    const pauseMedia = (mediaElement) => {
      if (!mediaElement) return;

      mediaElement.querySelectorAll('video').forEach((video) => video.pause());
      mediaElement.querySelectorAll('model-viewer').forEach((model) => {
        if (typeof model.pause === 'function') model.pause();
      });
      mediaElement.querySelectorAll('iframe').forEach((iframe) => {
        iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
      });
    };

    const initProduct = (root) => {
      if (root.dataset.productInitialized === 'true') return;
      root.dataset.productInitialized = 'true';

      const mediaItems = Array.from(root.querySelectorAll('[data-product-media]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-media-thumbnail]'));
      const galleryStage = root.querySelector('[data-gallery-stage]');
      const thumbnailScroller = root.querySelector('[data-thumbnail-scroller]');
      const thumbnailPreviousButton = root.querySelector('[data-thumbnails-previous]');
      const thumbnailNextButton = root.querySelector('[data-thumbnails-next]');
      const thumbnailPreviousHint = root.querySelector('[data-thumbnail-hint-previous]');
      const thumbnailNextHint = root.querySelector('[data-thumbnail-hint-next]');
      const variantOptions = Array.from(root.querySelectorAll('[data-variant-option]'));
      const businessDetails = root.querySelector('[data-business-variant-details]');
      const businessSummary = root.querySelector('[data-business-variant-summary]');
      const priceElement = root.querySelector('[data-variant-price]');
      const compareElement = root.querySelector('[data-variant-compare-price]');
      const detailElement = root.querySelector('[data-variant-detail]');
      const packBadge = root.querySelector('[data-gallery-pack-badge]');
      const packBadgeCount = root.querySelector('[data-gallery-pack-count]');
      const packBadgeUnit = root.querySelector('[data-gallery-pack-unit]');
      const quantityInput = root.querySelector('[data-quantity-input]');
      const decreaseButton = root.querySelector('[data-quantity-decrease]');
      const increaseButton = root.querySelector('[data-quantity-increase]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const lineTotal = root.querySelector('[data-line-total]');
      const paymentContainer = root.querySelector('[data-payment-container]');

      let activeMediaIndex = Math.max(0, mediaItems.findIndex((item) => !item.hidden));
      let currentPrice = Number(variantOptions.find((option) => option.checked)?.dataset.price || 0);
      let swipeStart = null;
      const requestedImageLoads = new WeakSet();
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const formatMoney = (cents) => {
        const locale = root.dataset.locale || 'en-US';
        const currency = root.dataset.currency || 'USD';

        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
        } catch (_error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      };

      const prepareImage = (mediaItem, priority = 'low') => {
        if (mediaItem?.dataset.mediaType !== 'image') return;

        const image = mediaItem.querySelector('img');
        if (!image) return;

        image.loading = 'eager';
        image.fetchPriority = priority;

        if (requestedImageLoads.has(image)) return;
        requestedImageLoads.add(image);
        image.decode?.().catch(() => {});
      };

      const prepareUpcomingImages = (mediaIndex) => {
        let preparedImageCount = 0;

        for (let offset = 1; offset < mediaItems.length && preparedImageCount < 2; offset += 1) {
          const nextIndex = (mediaIndex + offset) % mediaItems.length;
          const nextMedia = mediaItems[nextIndex];
          if (nextMedia.dataset.mediaType !== 'image') continue;

          prepareImage(nextMedia);
          preparedImageCount += 1;
        }
      };

      const updateThumbnailButtonState = () => {
        if (!thumbnailScroller || !thumbnailPreviousButton || !thumbnailNextButton) return;
        const maximumScroll = Math.max(0, thumbnailScroller.scrollWidth - thumbnailScroller.clientWidth);
        const canScrollPrevious = thumbnailScroller.scrollLeft > 2;
        const canScrollNext = thumbnailScroller.scrollLeft < maximumScroll - 2;

        thumbnailPreviousButton.disabled = !canScrollPrevious;
        thumbnailNextButton.disabled = !canScrollNext;
        if (thumbnailPreviousHint) thumbnailPreviousHint.hidden = !canScrollPrevious;
        if (thumbnailNextHint) thumbnailNextHint.hidden = !canScrollNext;
      };

      const updateThumbnailNavigation = () => {
        if (!thumbnailScroller || !thumbnailPreviousButton || !thumbnailNextButton) return;

        thumbnailPreviousButton.hidden = true;
        thumbnailNextButton.hidden = true;
        const isScrollable = thumbnailScroller.scrollWidth - thumbnailScroller.clientWidth > 2;
        thumbnailPreviousButton.hidden = !isScrollable;
        thumbnailNextButton.hidden = !isScrollable;
        updateThumbnailButtonState();
      };

      const keepThumbnailVisible = (thumbnail, behavior = 'smooth', revealAdjacent = false) => {
        if (!thumbnailScroller || !thumbnail) return;

        const scrollerBounds = thumbnailScroller.getBoundingClientRect();
        const thumbnailBounds = thumbnail.getBoundingClientRect();
        const safeInset = 4;
        let scrollDelta = 0;

        if (revealAdjacent) {
          const edgeZone = Math.min(76, thumbnailScroller.clientWidth * 0.25);
          const isNearPreviousEdge = thumbnailBounds.left < scrollerBounds.left + edgeZone;
          const isNearNextEdge = thumbnailBounds.right > scrollerBounds.right - edgeZone;

          if (isNearPreviousEdge || isNearNextEdge) {
            const maximumScroll = Math.max(0, thumbnailScroller.scrollWidth - thumbnailScroller.clientWidth);
            const centeredPosition = thumbnail.offsetLeft - (thumbnailScroller.clientWidth - thumbnail.offsetWidth) / 2;
            const targetPosition = Math.min(maximumScroll, Math.max(0, centeredPosition));
            thumbnailScroller.scrollTo({ left: targetPosition, behavior });
            return;
          }
        }

        if (thumbnailBounds.left < scrollerBounds.left + safeInset) {
          scrollDelta = thumbnailBounds.left - scrollerBounds.left - safeInset;
        } else if (thumbnailBounds.right > scrollerBounds.right - safeInset) {
          scrollDelta = thumbnailBounds.right - scrollerBounds.right + safeInset;
        }

        if (Math.abs(scrollDelta) > 1) {
          thumbnailScroller.scrollBy({ left: scrollDelta, behavior });
        }
      };

      const showMedia = (mediaId) => {
        const nextIndex = mediaItems.findIndex((item) => item.dataset.mediaId === String(mediaId));
        if (nextIndex < 0) return;

        prepareImage(mediaItems[nextIndex], 'high');

        mediaItems.forEach((item, index) => {
          const isActive = index === nextIndex;
          if (!isActive && !item.hidden) pauseMedia(item);
          item.hidden = !isActive;
          item.classList.toggle('is-active', isActive);
        });

        let activeThumbnail = null;
        thumbnails.forEach((thumbnail) => {
          const isActive = thumbnail.dataset.mediaThumbnail === String(mediaId);
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-pressed', String(isActive));
          if (isActive) activeThumbnail = thumbnail;
        });

        activeMediaIndex = nextIndex;
        prepareUpcomingImages(activeMediaIndex);
        keepThumbnailVisible(activeThumbnail, prefersReducedMotion ? 'auto' : 'smooth', true);
      };

      thumbnails.forEach((thumbnail) => {
        const prepareThumbnailImage = () => {
          const mediaItem = mediaItems.find((item) => item.dataset.mediaId === thumbnail.dataset.mediaThumbnail);
          prepareImage(mediaItem);
        };

        thumbnail.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') showMedia(thumbnail.dataset.mediaThumbnail);
        });
        thumbnail.addEventListener('pointerdown', prepareThumbnailImage);
        thumbnail.addEventListener('focus', prepareThumbnailImage);
        thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaThumbnail));
      });

      thumbnailPreviousButton?.addEventListener('click', () => {
        thumbnailScroller?.scrollBy({
          left: -Math.max(80, thumbnailScroller.clientWidth * 0.75),
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      });

      thumbnailNextButton?.addEventListener('click', () => {
        thumbnailScroller?.scrollBy({
          left: Math.max(80, thumbnailScroller.clientWidth * 0.75),
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      });

      thumbnailScroller?.addEventListener('scroll', updateThumbnailButtonState, { passive: true });
      window.addEventListener('resize', updateThumbnailNavigation);

      galleryStage?.addEventListener('touchstart', (event) => {
        if (event.target.closest('button, video, iframe, model-viewer')) return;
        const touch = event.changedTouches[0];
        swipeStart = { x: touch.clientX, y: touch.clientY };
      }, { passive: true });

      galleryStage?.addEventListener('touchend', (event) => {
        if (!swipeStart || mediaItems.length < 2) return;
        const touch = event.changedTouches[0];
        const horizontalDistance = touch.clientX - swipeStart.x;
        const verticalDistance = touch.clientY - swipeStart.y;
        swipeStart = null;

        if (Math.abs(horizontalDistance) < 48 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance) * 1.2) return;
        const direction = horizontalDistance < 0 ? 1 : -1;
        const nextIndex = (activeMediaIndex + direction + mediaItems.length) % mediaItems.length;
        showMedia(mediaItems[nextIndex].dataset.mediaId);
      }, { passive: true });

      const normalizeQuantity = (requestedValue) => {
        const minimum = Number(quantityInput?.min || 1);
        const increment = Number(quantityInput?.step || 1);
        const maximum = quantityInput?.max ? Number(quantityInput.max) : Number.POSITIVE_INFINITY;
        const safeValue = Number.isFinite(requestedValue) ? requestedValue : minimum;
        const steppedValue = minimum + Math.round((safeValue - minimum) / increment) * increment;
        return Math.min(maximum, Math.max(minimum, steppedValue));
      };

      const updateQuantityState = (requestedValue) => {
        if (!quantityInput) return;
        const quantity = normalizeQuantity(requestedValue);
        quantityInput.value = String(quantity);

        const minimum = Number(quantityInput.min || 1);
        const maximum = quantityInput.max ? Number(quantityInput.max) : Number.POSITIVE_INFINITY;
        if (decreaseButton) decreaseButton.disabled = quantity <= minimum;
        if (increaseButton) increaseButton.disabled = quantity >= maximum;
        if (lineTotal) lineTotal.textContent = formatMoney(currentPrice * quantity);
      };

      decreaseButton?.addEventListener('click', () => {
        const increment = Number(quantityInput?.step || 1);
        updateQuantityState(Number(quantityInput?.value || 1) - increment);
      });

      increaseButton?.addEventListener('click', () => {
        const increment = Number(quantityInput?.step || 1);
        updateQuantityState(Number(quantityInput?.value || 1) + increment);
      });

      quantityInput?.addEventListener('change', () => updateQuantityState(Number(quantityInput.value)));

      const selectVariant = (option) => {
        currentPrice = Number(option.dataset.price || 0);
        const comparePrice = Number(option.dataset.comparePrice || 0);
        const isAvailable = option.dataset.available === 'true';

        if (businessDetails?.contains(option)) businessDetails.open = true;

        if (priceElement) priceElement.textContent = option.dataset.priceFormatted || formatMoney(currentPrice);
        if (compareElement) {
          compareElement.hidden = comparePrice <= currentPrice;
          compareElement.textContent = option.dataset.compareFormatted || formatMoney(comparePrice);
        }
        if (detailElement) detailElement.textContent = option.dataset.detail || '';
        if (packBadge) {
          const boxCount = option.dataset.boxCount || '';
          const boxUnit = option.dataset.boxUnit || '';
          if (packBadgeCount) packBadgeCount.textContent = boxCount;
          if (packBadgeUnit) packBadgeUnit.textContent = boxUnit;
          packBadge.hidden = !boxCount || !boxUnit;
        }

        if (quantityInput) {
          quantityInput.min = option.dataset.quantityMin || '1';
          quantityInput.step = option.dataset.quantityIncrement || '1';
          if (option.dataset.quantityMax) quantityInput.max = option.dataset.quantityMax;
          else quantityInput.removeAttribute('max');
          updateQuantityState(Number(quantityInput.value));
        }

        if (addButton) addButton.disabled = !isAvailable;
        if (addLabel) addLabel.textContent = isAvailable ? root.dataset.addLabel : root.dataset.soldOutLabel;
        if (paymentContainer) paymentContainer.hidden = !isAvailable;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };

      variantOptions.forEach((option) => {
        option.addEventListener('change', () => {
          if (option.checked) selectVariant(option);
        });
      });

      businessSummary?.addEventListener('click', (event) => {
        const selectedBusinessOption = businessDetails?.querySelector('[data-variant-option]:checked');

        if (businessDetails?.open && selectedBusinessOption) event.preventDefault();
      });

      const tabs = Array.from(root.querySelectorAll('[data-product-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-product-panel]'));

      const activateTab = (nextTab, shouldFocus = false) => {
        tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
        });

        if (shouldFocus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });

      updateQuantityState(Number(quantityInput?.value || 1));
      prepareImage(mediaItems[activeMediaIndex], 'high');
      prepareUpcomingImages(activeMediaIndex);
      requestAnimationFrame(() => {
        updateThumbnailNavigation();
        keepThumbnailVisible(thumbnails[activeMediaIndex], 'auto');
      });
    };

    const initAllProducts = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initProduct);
    };

    initAllProducts();
    document.addEventListener('shopify:section:load', (event) => initAllProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
